import config from './config';
import apiFactory from './api';

export default apiFactory({
  apiPrefix: config.apiPrefix,
  gisPrefix: config.gisPrefix
});



// WEBPACK FOOTER //
// ./src/apiSingleton.js